import React, { useMemo } from "react";

/**
 * Shutter Speed Trail — subtle light-streak overlay radiating from the reticle
 * when the current shutter is too slow for the room's action. Educational cue
 * so students SEE why the runner smears / the frame blurs.
 */
const ShutterTrail = ({ excess }) => {
    const { streaks, intensity } = useMemo(() => {
        if (!excess || excess <= 0) return { streaks: [], intensity: 0 };
        const int = Math.min(1, excess / 6);            // 0..1
        const streakCount = 6;
        const length = 26 + int * 42;                    // px
        const maxOpacity = 0.25 + int * 0.55;
        const minOpacity = 0.08 + int * 0.2;
        const built = Array.from({ length: streakCount }, (_, i) => {
            const angle = i * (360 / streakCount) + (i % 2 ? 8 : -6);
            return { angle, length, maxOpacity, minOpacity, delay: i * 90 };
        });
        return { streaks: built, intensity: int };
    }, [excess]);

    if (!streaks.length) return null;

    return (
        <div
            className="pointer-events-none absolute inset-0"
            data-testid="shutter-trail"
            data-intensity={intensity.toFixed(2)}
            aria-hidden="true"
        >
            {streaks.map((s, i) => (
                <span
                    key={i}
                    className="shutter-streak"
                    style={{
                        width: `${s.length}px`,
                        background: `linear-gradient(90deg, rgba(255,245,220,${s.maxOpacity}) 0%, rgba(255,180,120,${s.maxOpacity * 0.6}) 40%, transparent 100%)`,
                        transform: `rotate(${s.angle}deg) translateX(20px)`,
                        animationDelay: `${s.delay}ms`,
                        "--trail-min": s.minOpacity,
                        "--trail-max": s.maxOpacity,
                    }}
                />
            ))}
        </div>
    );
};

export default ShutterTrail;
